import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TrackingActions, TrackingDeliveryApiService } from '@tracking/data-access';
import { Observable, of } from 'rxjs';
import { catchError, distinctUntilChanged, map, pairwise, switchMap } from 'rxjs/operators';

@Injectable()
export class TrackingDeliveryEffect {
  load$: Observable<TrackingActions.TrackingDeliveryLoadSuccess | TrackingActions.TrackingDeliveryLoadFail> =
    createEffect(() =>
      this.actions$.pipe(
        ofType(TrackingActions.LOAD_TRACKING_DELIVERY),
        map((action: TrackingActions.TrackingDeliveryLoad) => action.trackingId),
        distinctUntilChanged(),
        switchMap((trackingId) => {
          return this.trackingApiService.load(trackingId).pipe(
            map((response) => new TrackingActions.TrackingDeliveryLoadSuccess(trackingId, response)),
            catchError((error) => of(new TrackingActions.TrackingDeliveryLoadFail(trackingId, error))),
          );
        }),
      ),
    );

  resetPrevious$: Observable<TrackingActions.TrackingDeliveryReset> = createEffect(() =>
    this.actions$.pipe(
      ofType(TrackingActions.LOAD_TRACKING_DELIVERY),
      map((action: TrackingActions.TrackingDeliveryLoad) => action.trackingId),
      distinctUntilChanged(),
      pairwise(),
      map(([prevTrackingId]) => new TrackingActions.TrackingDeliveryReset(prevTrackingId)),
    ),
  );

  constructor(
    private actions$: Actions,
    private trackingApiService: TrackingDeliveryApiService,
  ) {}
}
